import solidFrameBackgroundImg from '../screens/components/atomic/dialog/solid_frame_background/solid_frame_background.png';
import dialogBodyFrameBackgroundImg from '../screens/components/atomic/dialog/dialog_body_frame_background/dialog_body_frame_background.png';
import whatInsideTextSvg from '../screens/components/atomic/delivery_dialog/what_inside_text/what_inside_text.svg';
import confettiImg from '../screens/components/atomic/effects/confetti/confetti.png';
import flashImg from '../screens/components/atomic/buttons/button/flash.png';
import goBackArrowImg from '../screens/components/atomic/buttons/go_back_button/arrow_icon.png';
import hideDeliveryItemImg from '../screens/new_delivery_screen/content/hide_delivery_item_image.png';
import newDeliveryHeaderTextImg from '../screens/new_delivery_screen/texts/header_text.png';
import takeOrderTextImg from '../screens/new_delivery_screen/texts/take_order.png';
import openedDeliveryItemBg from '../screens/success_delivery_screen/content/opened_delivery_item_background.png';
import { getGiantBadgeIconAssetUrls } from '../screens/components/atomic/giants/giant_icons/giantIconAssets';

export const HIDE_DELIVERY_ITEM_IMAGE_URL = hideDeliveryItemImg;
export const OPENED_DELIVERY_ITEM_BACKGROUND_URL = openedDeliveryItemBg;
export const CONFETTI_IMAGE_URL = confettiImg;
export const SOLID_FRAME_BACKGROUND_URL = solidFrameBackgroundImg;
export const DIALOG_BODY_FRAME_BACKGROUND_URL = dialogBodyFrameBackgroundImg;

export function getDeliveryDialogAssetUrls(): string[] {
  return [
    solidFrameBackgroundImg,
    dialogBodyFrameBackgroundImg,
    whatInsideTextSvg,
    confettiImg,
    hideDeliveryItemImg,
    openedDeliveryItemBg,
    newDeliveryHeaderTextImg,
    takeOrderTextImg,
    goBackArrowImg,
    flashImg,
    ...getGiantBadgeIconAssetUrls(),
  ];
}
